{
  "name": "@blockdaemon/earn-widget",
  "version": "1.100.3",
  "private": true,
  "type": "module",
  "exports": {
    ".": "./src/main.tsx",
    "./router": {
      "types": "./src/create-earn-router.d.ts",
      "default": "./src/create-earn-router.tsx"
    },
    "./config": "./src/features/customization/hooks/use-widget-config.tsx",
    "./config-loader": "./src/features/customization/utils/config-loader.ts",
    "./config-schema": "./src/features/customization/lib/config-schema.ts",
    "./currency-switcher": "./src/shared/components/currency-switcher.tsx",
    "./navigation": "./src/shared/utils/navigation-utils.ts",
    "./showcase-adapter": "./src/showcase-adapter.tsx",
    "./locales/*": "./src/locales/*",
    "./demo": {
      "workerd": "./worker/config/demo.json",
      "worker": "./worker/config/demo.json",
      "module": "./worker/config/demo.json",
      "browser": "./worker/config/demo.json",
      "development": "./worker/config/demo.json",
      "import": "./worker/config/demo.json",
      "default": "./worker/config/demo.json"
    }
  },
  "scripts": {
    "dev": "vite dev --port 5173",
    "build": "tsc -b && vite build",
    "routes:generate": "tsr generate"
  },
  "dependencies": {
    "@blockdaemon-internal/design-system": "catalog:",
    "@blockdaemon/bd-sdk": "catalog:",
    "@blockdaemon/widget-config": "workspace:*",
    "@blockdaemon/widget-host": "workspace:*",
    "@blockdaemon/widget-metadata": "workspace:*",
    "@blockdaemon/widget-shell": "workspace:*",
    "@blockdaemon/widget-tooling": "workspace:*",
    "@blockdaemon/widget-worker": "workspace:*",
    "@lingui/core": "catalog:",
    "@lingui/react": "catalog:",
    "@mantine/core": "catalog:",
    "@mantine/hooks": "catalog:",
    "@mantine/spotlight": "catalog:",
    "@reown/appkit": "catalog:",
    "@reown/appkit-adapter-solana": "catalog:",
    "@reown/appkit-adapter-wagmi": "catalog:",
    "@reown/appkit-common": "catalog:",
    "@sentry/react": "catalog:",
    "@solana/web3.js": "catalog:",
    "@tanstack/react-form": "catalog:",
    "@tanstack/react-query": "catalog:",
    "@tanstack/react-query-devtools": "catalog:",
    "@tanstack/react-router": "catalog:",
    "@tanstack/react-router-devtools": "catalog:",
    "@tanstack/zod-adapter": "catalog:",
    "@wagmi/core": "catalog:",
    "buffer": "catalog:",
    "dayjs": "catalog:",
    "hono": "catalog:",
    "lucide-react": "catalog:",
    "motion": "catalog:",
    "posthog-js": "catalog:",
    "react": "catalog:",
    "react-dom": "catalog:",
    "viem": "catalog:",
    "wagmi": "catalog:",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@lingui/babel-plugin-lingui-macro": "catalog:",
    "@tanstack/router-cli": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "babel-plugin-react-compiler": "catalog:",
    "bun-types": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:"
  }
}
